module.exports = __webpack_public_path__ + "static/media/MushroomTown.bc318186.png";